<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="12">
            <a-form-item label="账号">
              <!--<a-input placeholder="请输入账号查询" v-model="queryParam.username"></a-input>-->
              <a-input placeholder="输入账号模糊查询" v-model="queryParam.username" allowClear></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="用户姓名">
              <a-input placeholder="请输入真实名字" v-model="queryParam.realname" allowClear></a-input>
            </a-form-item>
          </a-col>
          
          <a-col :md="6" :sm="8">
            <a-form-item label="手机号码">
              <a-input placeholder="请输入手机号码查询" v-model="queryParam.phone" allowClear></a-input>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            
          <a-col :md="6" :sm="8">
            <a-form-item label="用户类型">
              <a-select v-model="queryParam.userType" placeholder="请选择用户类型" allowClear>
                <a-select-option value="employee">员工</a-select-option>
                <a-select-option value="nonemployee">非员工</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
            <a-col :md="6" :sm="8">
              <a-form-item label="用户状态">
                <a-select v-model="queryParam.status" placeholder="请选择" allowClear>
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">正常</a-select-option>
                  <a-select-option value="2">冻结</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :xl="10" :lg="11" :md="12" :sm="24" v-if="application.applicationType === 'platform'">
              <a-form-item label="应用">
                <a-select v-model="queryParam.selectedApplicationId" allowClear  placeholder="请选择应用" style="width: 35%;padding-right: 10px">
                  <a-select-option v-for="(item,index) in applicationOptions" :key="index" :value="item.id" allowClear>
                    {{ item.applicationName }}
                  </a-select-option>
                </a-select>
                <a-radio-group v-model="queryParam.applicationBy" @change="change">
                  <a-radio value="user">用户</a-radio>
                  <a-radio value="role">角色</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>

          </template>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" v-has="'puserlist:search'"  @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" v-has="'puserlist:reset'"  @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" style="border-top: 5px">
      <!-- <a-button @click="handleAdd" type="primary" icon="plus" >添加用户</a-button> -->
     <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <!-- <a-menu-item key="1">
            <a-icon type="delete" @click="batchDel"/>
            删除
          </a-menu-item> -->
          <a-menu-item key="2" v-has="'puserlist:batchFrozenlock'">
            <a-icon type="lock" @click="batchFrozen('2')"/>
            冻结
          </a-menu-item>
          <a-menu-item key="3" v-has="'puserlist:batchFrozenunlock'">
            <a-icon type="unlock" @click="batchFrozen('1')"/>
            解冻
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>已选择&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange"
         :scroll="{x:1700}">

        <template slot="avatarslot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a v-has="'puserlist:edit'" @click="handleEdit(record)" >编辑</a>
          <a-divider type="vertical" />
          <a v-has="'puserlist:dataAutho'" @click="dataAutho(record)" >数据授权</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多 <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'puserlist:detail'" >
                <a href="javascript:;" @click="handleDetail(record)">详情</a>
              </a-menu-item>

              <a-menu-item v-has="'puserlist:password'">
                <a href="javascript:;" @click="handleChangePassword(record.username)">密码</a>
              </a-menu-item>

              <a-menu-item v-if="record.status==1"   v-has="'puserlist:frozen'">
                <a-popconfirm title="确定冻结吗?" @confirm="() => handleFrozen(record.id,2,record.username)">
                  <a>冻结</a>
                </a-popconfirm>
              </a-menu-item>

              <a-menu-item v-if="record.status==2"  v-has="'puserlist:unfrozen'" >
                <a-popconfirm title="确定解冻吗?" @confirm="() => handleFrozen(record.id,1,record.username)">
                  <a>解冻</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->

    <user-modal ref="modalForm" @ok="modalFormOk"></user-modal>

    <password-modal ref="passwordmodal" @ok="passwordModalOk"></password-modal>
    
    <data-modal ref="datamodal"></data-modal>
  </a-card>
</template>

<script>
  import UserModal from './modules/UserModal'
  import PasswordModal from './modules/PasswordModal'
  import DataModal from './modules/DataModal.vue'
  import {getAction,postAction,putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch,applicationList} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'
  import JThirdAppButton from '@/components/jeecgbiz/thirdApp/JThirdAppButton'

  export default {
    name: "UserList",
    mixins: [JeecgListMixin],
    components: {
      JThirdAppButton,
      UserModal,
      PasswordModal,
      DataModal,
      JInput,
      JSuperQuery,
    },
    data() {
      return {
        description: '用户维护',
        queryParam: {applicationBy:'user',selectedApplicationId:'1526828958439706625'},
        recycleBinVisible: false,
        applicationOptions:[],
        selectedApplicationId:'',
        uploadSource:"platform",
        columns: [
          {
            title: '用户账号',
            align: "center",
            dataIndex: 'username',
            width: 200,
            sorter: true
          },
          {
            title: '用户姓名',
            align: "center",
            width: 200,
            dataIndex: 'realname',
          },
          /* {
            title: '厂区',
            align: "center",
            width: 150,
            dataIndex: 'factoryName',
          },
          {
            title: '区域',
            align: "center",
            width: 150,
            dataIndex: 'areaName',
          },
          {
            title: '楼栋',
            align: "center",
            width: 150,
            dataIndex: 'buildingName',
          }, */
          /* {
            title: '头像',
            align: "center",
            width: 80,
            dataIndex: 'avatar',
            scopedSlots: {customRender: "avatarslot"}
          },

          {
            title: '性别',
            align: "center",
            width: 80,
            dataIndex: 'sex_dictText',
            sorter: true
          }, */
          {
            title: '用户类型',
            align: "center",
            dataIndex: 'userType_dictText',
            width: 120,
          },
          /* {
            title: '生日',
            align: "center",
            width: 120,
            dataIndex: 'birthday'
          }, */
          {
            title: '手机号码',
            align: "center",
            width: 120,
            dataIndex: 'phone'
          },
          {
            title: '邮箱',
            align: "center",
            width: 200,
            dataIndex: 'email'
          },
           {
            title: '注册时间',
            align: "center",
            width: 200,
            dataIndex: 'createTime'
          },
          {
            title: '最后登录时间',
            align: "center",
            width: 200,
            dataIndex: 'loginLastTime'
          },
          /* {
            title: '负责部门',
            align: "center",
            width: 300,
            dataIndex: 'responsibleDepartName'
          }, */
          {
            title: '状态',
            align: "center",
            // width: 80,
            dataIndex: 'status_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action'},
            align: "center",
            width: 220,
            fixed:"right"
          }

        ],
        superQueryFieldList: [
          { type: 'input', value: 'username', text: '用户账号', },
          { type: 'input', value: 'realname', text: '用户姓名', },
          { type: 'select', value: 'sex', dbType: 'int', text: '性别', dictCode: 'sex' },
        ],
        url: {
          list: "/sys/user/list",
        },
        application:{},
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    created() {
      this.getThisapplication();
    },
    methods: {
      searchReset() {
        this.queryParam ={
          applicationBy:'user',selectedApplicationId:this.application.id
        }
        this.loadData(1);
      },
      change(e){
        this.queryParam.applicationBy = e.target.value
      },
      dataAutho(record){
         this.$refs.datamodal.edit(record.id,record.username);
      },
      handleEdit(record){
        let params = {
          id: record.id,
        };
        getAction("/sys/user/getUserApplications", params).then((res)=> {
          if (res.success) {
            let apps = [];
            let list = res.result;
            if(list){
              list.forEach(item=>{
                apps.push(item.id)
              })
            }
            this.$refs.modalForm.title = "编辑";
            record.setEdit = true;
            this.$refs.modalForm.edit(record,apps);
          }
        })

      },
      getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar,this.uploadSource)
      },

      batchFrozen: function (status) {
        if (this.selectedRowKeys.length <= 0) {
          this.$message.warning('请选择一条记录！');
          return false;
        } else {
          let ids = "";
          let that = this;
          let isAdmin = false;
          that.selectionRows.forEach(function (row) {
            if (row.username == 'admin') {
              isAdmin = true;
            }
          });
          if (isAdmin) {
            that.$message.warning('管理员账号不允许此操作,请重新选择！');
            return;
          }
          that.selectedRowKeys.forEach(function (val) {
            ids += val + ",";
          });
          that.$confirm({
            title: "确认操作",
            content: "是否" + (status == 1 ? "解冻" : "冻结") + "选中账号?",
            onOk: function () {
              frozenBatch({ids: ids, status: status}).then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              });
            }
          });
        }
      },
      handleMenuClick(e) {
        if (e.key == 1) {
          this.batchDel();
        } else if (e.key == 2) {
          this.batchFrozen(2);
        } else if (e.key == 3) {
          this.batchFrozen(1);
        }
      },
      handleFrozen: function (id, status, username) {
        let that = this;
        //TODO 后台校验管理员角色
        if ('admin' == username) {
          that.$message.warning('管理员账号不允许此操作！');
          return;
        }
        frozenBatch({ids: id, status: status}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData();
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      handleChangePassword(username) {
        this.$refs.passwordmodal.show(username);
      },
      passwordModalOk() {
        //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
      },
      datamodalOk(){
        
      },
      onSyncFinally({isToLocal}) {
        // 同步到本地时刷新下数据
        if (isToLocal) {
          this.loadData()
        }
      },
      getThisapplication(){
        let param = {}
        param.code = this.$store.getters.applicationCode
        getAction("/sys/sysBmApplication/queryByCode", param).then((res) => {
          if (res.success) {
            this.application = res.result;
            if(res.result.applicationType === 'platform'){
            }else{
              this.queryParam = {selectedApplicationId:this.application.id,applicationBy:'user'}
              this.loadData(1);
            }
          }
        })
      },
      bindApplication(record){
        this.$refs.UserApplicationModel.edit(record);
      },
    }

  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>